import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SessionInfoCard = ({ session }) => {
  const [isAddressCopied, setIsAddressCopied] = useState(false);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('ko-KR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long'
    });
  };

  const formatTime = (timeString) => {
    return timeString;
  };

  const handleCopyAddress = async () => {
    const address = String(session?.venueAddress || '').trim();
    if (!address) return;

    try {
      await navigator.clipboard?.writeText(address);
      setIsAddressCopied(true);
      setTimeout(() => setIsAddressCopied(false), 1500);
    } catch {
      try {
        const el = document.createElement('textarea');
        el.value = address;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        setIsAddressCopied(true);
        setTimeout(() => setIsAddressCopied(false), 1500);
      } catch {
        // ignore
      }
    }
  };

  return (
    <div className="bg-card border border-border rounded-xl p-4 md:p-6 lg:p-8 shadow-md">
      <div className="flex items-start gap-3 md:gap-4 mb-4 md:mb-6">
        <div className="w-12 h-12 md:w-16 md:h-16 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
          <Icon name={session?.sportIcon} size={24} color="var(--color-primary)" className="md:w-8 md:h-8" />
        </div>
        <div className="flex-1 min-w-0">
          <h1 className="text-xl md:text-2xl lg:text-3xl font-heading font-bold text-foreground mb-1 md:mb-2">
            {session?.title}
          </h1>
          <p className="text-sm md:text-base caption text-muted-foreground">
            {session?.venue}
          </p>
          {String(session?.venueAddress || '').trim() && (
            <div className="mt-1 flex items-center gap-2">
              <p className="text-xs md:text-sm caption text-muted-foreground truncate flex-1">
                {session?.venueAddress}
              </p>
              <Button
                type="button"
                variant="outline"
                size="sm"
                onClick={handleCopyAddress}
              >
                {isAddressCopied ? '복사됨' : '복사'}
              </Button>
            </div>
          )}
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4 lg:gap-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-accent/10 rounded-md flex items-center justify-center flex-shrink-0">
            <Icon name="Calendar" size={20} color="var(--color-accent)" />
          </div>
          <div className="min-w-0">
            <p className="text-xs md:text-sm caption text-muted-foreground">날짜</p>
            <p className="text-sm md:text-base font-medium text-foreground truncate">
              {formatDate(session?.date)}
            </p>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-accent/10 rounded-md flex items-center justify-center flex-shrink-0">
            <Icon name="Clock" size={20} color="var(--color-accent)" />
          </div>
          <div className="min-w-0">
            <p className="text-xs md:text-sm caption text-muted-foreground">시간</p>
            <p className="text-sm md:text-base font-medium text-foreground">
              {formatTime(session?.startTime)} - {formatTime(session?.endTime)}
            </p>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-accent/10 rounded-md flex items-center justify-center flex-shrink-0">
            <Icon name="MapPin" size={20} color="var(--color-accent)" />
          </div>
          <div className="min-w-0">
            <p className="text-xs md:text-sm caption text-muted-foreground">장소</p>
            <p className="text-sm md:text-base font-medium text-foreground truncate">
              {session?.location}
            </p>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-accent/10 rounded-md flex items-center justify-center flex-shrink-0">
            <Icon name="Target" size={20} color="var(--color-accent)" />
          </div>
          <div className="min-w-0">
            <p className="text-xs md:text-sm caption text-muted-foreground">실력 범위</p>
            <p className="text-sm md:text-base font-medium text-foreground">
              {session?.skillRange}
            </p>
          </div>
        </div>
      </div>
      {session?.description && (
        <div className="mt-4 md:mt-6 pt-4 md:pt-6 border-t border-border">
          <p className="text-sm md:text-base text-foreground whitespace-pre-line">
            {session?.description}
          </p>
        </div>
      )}
    </div>
  );
};

export default SessionInfoCard;